export function isEmptyTimeSpanMask(timeSpanValue : string){
    if(timeSpanValue == null){
        return true
    }
    if(timeSpanValue == ''){
        return true
    }

    if(timeSpanValue == '  :  '){
        return true
    }
    return false
}